import React from "react";

const ConfigPaudSmpMTsPaketB = {
    Apk: {
        title: "APK SLB",
        data: [],
        columns: [
            {
                Header: 'Wilayah',
                columns: [
                    {
                        Header: '',
                        accessor: 'kecamatan',
                        Cell: ({ row }) => (
                            <div style={{ textAlign: "left" }}>
                                {row.original.kecamatan}
                            </div>
                        )
                    },
                ]
            },
            {
                Header: 'Jumlah Penduduk 7-18',
                columns: [
                    {
                        Header: 'L',
                        accessor: 'jp10718_laki_laki',
                    },
                    {
                        Header: 'P',
                        accessor: 'jp10718_perempuan',
                    },
                    {
                        Header: 'Jumlah',
                        accessor: 'jp10718_jumlah',
                    },
                ]
            },
        ]
    },
    Apm: {
        title: "APM SLB",
        data: [],
        columns: [
            {
                Header: 'Wilayah',
                columns: [
                    {
                        Header: '',
                        accessor: 'kecamatan',
                        Cell: ({ row }) => (
                            <div style={{ textAlign: "left" }}>
                                {row.original.kecamatan}
                            </div>
                        )
                    },
                ]
            },
            {
                Header: 'Jumlah Penduduk 7-18',
                columns: [
                    {
                        Header: 'L',
                        accessor: 'jp10718_laki_laki',
                    },
                    {
                        Header: 'P',
                        accessor: 'jp10718_perempuan',
                    },
                    {
                        Header: 'Jumlah',
                        accessor: 'jp10718_jumlah',
                    },
                ]
            },
        ]
    }
}

export default ConfigPaudSmpMTsPaketB;